import {
    myOrderCountUrl,
    feedbackUrl,
    orderReportUrl,
    scHostInforUrl,
    personalInfoUrl,
    getMyBackupListUrl,
    applyBackupUrl,
    getSCListUrl,
    supplyCenterUrl,
    lockUnlockUrl,
    syncSTUrl,
    syncOnlineAccountUserUrl,
    getInventoryBySkuAndSCUrl,
    getAlphaInfoUrl,
    customerBackupUrl,
    stockupCancelUrl,
    sysDictUrl,
    getSystemNotificationUrl,
} from 'Utils/urlUtil';
import {post, get} from 'Utils/apiUtil';

export const ORDER_COUNT = 'ORDER_COUNT';
export const SC_HOST_INFOR = 'SC_HOST_INFOR';
export const PERSONAL_INFOR = 'PERSONAL_INFOR';
export const MY_BACKUP_LIST = 'MY_BACKUP_LIST';
export const SUPPLY_CENTER_LIST = 'SUPPLY_CENTER_LIST';
export const UPDATE_BACKUP_LIST = 'UPDATE_BACKUP_LIST';
export const GET_ALPHA_LIST = 'GET_ALPHA_LIST';
export const GET_INVENTORY_BY_SKU_AND_SC = 'GET_INVENTORY_BY_SKU_AND_SC';
export const SYS_DICT = 'SYS_DICT';
export const UPDATE_SUPPLY_CENTER_LIST = 'UPDATE_SUPPLY_CENTER_LIST';
export const GET_SYSTEM_NOTIFICATION = 'GET_SYSTEM_NOTIFICATION';
export const SET_SYSTEM_NOTIFICATION = 'SET_SYSTEM_NOTIFICATION';

export function getMyOrderCount() {
    return (dispatch) =>
        dispatch(get(myOrderCountUrl)).then((res) => {
            dispatch({type: ORDER_COUNT, payload: res});
        });
}

export function getPersonalInfo() {
    return (dispatch) =>
        dispatch(get(personalInfoUrl)).then((res) => {
            dispatch({type: PERSONAL_INFOR, payload: res});
            return res;
        });
}

export const submitFeedback = (params) => post(feedbackUrl, params);

export const getOrderReport = (params) => post(orderReportUrl, params);

export const lockUnlock = (params) => post(lockUnlockUrl, params);

export const stockupRevoke = (params) => post(stockupCancelUrl, params);

export function getHostInforList(params) {
    return (dispatch) =>
        dispatch(get(scHostInforUrl, params)).then((res) => {
            dispatch({type: SC_HOST_INFOR, payload: res});
        });
}

export const getMyBackupList = (data) => (dispatch) =>
    dispatch(post(getMyBackupListUrl, data)).then((res) => {
        dispatch({type: MY_BACKUP_LIST, payload: res});
        return res;
    });

export const updateBackupList = (params) => ({
    type: UPDATE_BACKUP_LIST,
    payload: params,
});

export const applyBackup = (data) => post(applyBackupUrl, data);

export const customerApplyBackup = (data) => post(customerBackupUrl, data);

export const getSCList = (shipTo) => {
    return (dispatch, getState) => {
        const {localData} = getState();

        let shipToNum = localData.shipToNum;
        if (typeof shipTo !== 'undefined') {
            shipToNum = shipTo;
        }
        switch (localData.roleType) {
            case 0:
            case 1:
                return dispatch(
                    get(supplyCenterUrl, {shipToNo: shipToNum}),
                ).then((res) => {
                    dispatch({type: SUPPLY_CENTER_LIST, payload: res.data});

                    return res;
                });
            case 2:
            case 3:
                if (typeof shipTo !== 'undefined') {
                    return dispatch(
                        get(supplyCenterUrl, {shipToNo: shipToNum}),
                    ).then((res) => {
                        dispatch({type: SUPPLY_CENTER_LIST, payload: res.data});

                        return res;
                    });
                } else {
                    return dispatch(get(getSCListUrl)).then((res) => {
                        dispatch({type: SUPPLY_CENTER_LIST, payload: res.data});

                        return res;
                    });
                }
            default:
        }
    };
};

export const syncST = (params) => get(syncSTUrl, params);

export const syncWebAccount = (params) => get(syncOnlineAccountUserUrl, params);

export const getAlphaList = (stAlpha) => {
    return (dispatch) =>
        dispatch(get(getAlphaInfoUrl, {stAlpha})).then((res) => {
            const data = res.data.map((d, i) => ({
                institution: d.institution,
                fullName: d.stAlphaName,
                id: i + 1,
            }));
            dispatch({type: GET_ALPHA_LIST, payload: data});
        });
};

export const getInventoryBySkuAndSC = (data) => (dispatch) =>
    dispatch(post(getInventoryBySkuAndSCUrl, data)).then((res) => {
        dispatch({type: GET_INVENTORY_BY_SKU_AND_SC, payload: res.data});
        return res;
    });

export function getSysDict(dictType) {
    return (dispatch) =>
        dispatch(get(sysDictUrl, {dictType})).then((res) => {
            dispatch({type: SYS_DICT, payload: res});
        });
}

export const updateMyOrderList = (params) => ({
    type: UPDATE_SUPPLY_CENTER_LIST,
    payload: params,
});

export const getSystemNotification = (data) => (dispatch) =>
    dispatch(post(getSystemNotificationUrl, data)).then((res) => {
        dispatch({type: GET_SYSTEM_NOTIFICATION, payload: res});
        return res;
    });

// Update SystemN otification
export const setSystemNotification = (params) => ({
    type: SET_SYSTEM_NOTIFICATION,
    payload: params,
});
